import React from "react";
import { SvgContainer } from "#ui";
import { useChartSwitcher } from "#hooks/use-chart-switcher";
import { LeftKPI } from "./LeftKPI";
import { RightKPI } from "./RightKPI";
import { ChartProps } from "#interfaces";

const CHART_COUNT = 2;

export const EmissionsChartDesktop: React.FC<Pick<ChartProps, "labels">> = ({ labels }) => {
  const chartProps = useChartSwitcher(CHART_COUNT);
  return (
    <SvgContainer viewBox="0 0 896 544" xmlns="http://www.w3.org/2000/svg">
      <LeftKPI labels={labels?.value1} {...chartProps} />
      <RightKPI labels={labels?.value2} {...chartProps} />
    </SvgContainer>
  );
};
